import { forEach } from 'lodash';
import moment from 'moment';
import { Dispatch } from 'react';
import { apiClient, apiErrorHandler } from 'src/app/common/network';
import { PaginateListMore } from '../../../common/types/common-types';
import { ReportItem, ReportListParams } from '../types/candidate-recruitment-pipeline';

const ADMIN_URL = `${window.envConfig['REACT_APP_APIM_BASE_URL']}${window.envConfig['REACT_APP_APIM_ADMIN']}`;

const toDate = (value?: Date | string): Date | undefined => {
  if (!value) {
    return undefined;
  }

  if (value instanceof Date) {
    return value;
  }

  const parsedDate = new Date(value);
  return Number.isNaN(parsedDate.getTime()) ? undefined : parsedDate;
};

const formatDataFilters = (params: ReportListParams) => {
  let data: any = {
    dataFilters: [],
    page: params.page,
    limit: params.limit,
  };
  forEach(params, (param, key) => {
    if (param) {
      switch (key) {
        case 'createdAtFrom':
          data.dataFilters.push({
            name: 'createdAt',
            value: param,
            type: 'Date',
            operator: 'gt',
          });
          break;
        case 'createdAtTo':
          data.dataFilters.push({
            name: 'createdAt',
            value: param,
            type: 'Date',
            operator: 'lt',
          });
          break;
        case 'agentCode':
          data.dataFilters.push({
            name: 'agentCode',
            value: param,
            type: 'String',
            operator: 'search',
          });
          break;
        case 'leaderCode':
          data.dataFilters.push({
            name: 'leaderCode',
            value: param,
            type: 'String',
            operator: 'search',
          });
          break;
        case 'unit':
          data.dataFilters.push({
            name: 'unit',
            value: param,
            type: 'String',
            operator: 'search',
          });
          break;
        case 'candidateName':
          data.dataFilters.push({
            name: 'candidateName',
            value: param,
            type: 'String',
            operator: 'search',
          });
          break;
        case 'phone':
          data.dataFilters.push({
            name: 'phone',
            value: param,
            type: 'String',
            operator: 'search',
          });
          break;
        case 'source':
          data.dataFilters.push({
            name: 'source',
            value: param,
            type: 'String',
            operator: 'search',
          });
          break;
      }
    }
  });

  return data;
};

export const fetchCandidateRecruitmentPipelineReportExport = (
  params: ReportListParams,
  dispatch?: Dispatch<any>,
): void => {
  const uri = `${ADMIN_URL}/report/candidate-pipeline/export`;
  const data = formatDataFilters(params);

  apiClient
    .post<Blob>(uri, data, { responseType: 'text' })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob(['\uFEFF' + response.data], { type: 'text/csv;charset=utf-8;' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        'Candidate Recruitment Pipeline Report_' + moment(new Date()).format('YYYYMMDD') + '.csv',
      );
      document.body.appendChild(link);
      link.click();
    })
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const fetchCandidateRecruitmentPipelineReport = async (
  params: ReportListParams,
  dispatch?: Dispatch<any>,
): Promise<PaginateListMore<ReportItem>> => {
  const uri = `${ADMIN_URL}/report/candidate-pipeline`;
  const data = formatDataFilters(params);

  return apiClient
    .post<PaginateListMore<ReportItem>>(uri, data)
    .then((response) => {
      const mappedItems = (response.data.items || []).map((item) => {
        return {
          ...item,
          created_time: item.created_time,
          calledDate: item.calledDate,
          timeContact: item.timeContact,
          appointmentSetTime: item.appointmentSetTime,
          attendedMeetingTime: item.attendedMeetingTime,
          checkinPocTime: item.checkinPocTime,
          checkinBopTime: item.checkinBopTime,
          nbriTime: item.nbriTime,
          bop1_1checkinTime: item.bop1_1checkinTime,
        };
      });

      return {
        ...response.data,
        items: mappedItems,
      };
    })
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};
